import { v1 as uuidv1 } from 'uuid';
import {
  Card,
  CardContent,
  CardActionArea,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './CardSelector.scss';

/**
 * Card selection that
 * allows the user to select one option from a set
 *
 * @param props of array of config object. An example is
 * config: [
 *  {
 *    component: bookLayoutOnePageComponent,
 *    dataValue: 'one-page',
 *    onSelect: (dataValue) => {console.log(dataValue)}
 *  },
 *  {
 *    component: bookLayouTwoPageComponent,
 *    dataValue: 'two-page',
 *    onSelect: (dataValue) => {console.log(dataValue)}
 *  },
 * ]
 *
 */
const defaultProps = {
  config: [],
  width: '100%',
  height: '50vh',
  align: 'left',
  selectedIndex: null,
  disabled: false,
  className: '',
};
export default function CardSelector(props) {
  const {
    config,
    width,
    height,
    align,
    selectedIndex,
    disabled,
    className,
  } = { ...defaultProps, ...filterUndefined(props) };
  const handleOnClick = (index) => {
    if (index === selectedIndex) {
      return;
    }
    if (config[index].onClick) {
      config[index].onClick(config[index].dataValue, index);
    }
  };

  const style = {
    width,
    height,
  };
  // by default it is left
  if (align === 'center') {
    style.margin = 'auto';
  }
  return (
    <div
      className={`card-selector-component ${disabled ? 'disable' : ''} ${className}`}
      style={{ ...style }}
    >
      {config.map((c, index) => (
        <Card
          data-test={`card-selector-option-${c.dataValue}`}
          key={uuidv1()}
          style={{ width: `calc( 100% / ${config.length})` }}
          onMouseUp={() => handleOnClick(index)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleOnClick(index);
            }
          }}
          tabIndex={config.length === 1 ? -1 : 0}
          className={`card-selector ${selectedIndex === index ? 'card-selected' : ''} vizzle-card-selector-${index}`}
        >
          <CardActionArea className='card-selector-action-area' tabIndex={-1}>
            <CardContent className='card-selector-action-area-content'>
              {c.component}
            </CardContent>
          </CardActionArea>
        </Card>
      ))}
    </div>
  );
}
